// extracted by mini-css-extract-plugin
export default {"containerHeading":"Section_containerHeading__Nhk0T","heading":"Section_heading__J2qaV","paragraph":"Section_paragraph__gX1Z-"};